module.exports = "images/doc-activity-add-1.35b78a89cda721ec7307e3357172c028.png";